import React from "react";
import CollectionsBookmarkIcon from "@material-ui/icons/CollectionsBookmark";
function Header() {
  return (
    <header>
      <h1 id="header_title">
        <CollectionsBookmarkIcon font-ize="medium" /> Cache
      </h1>
    </header>
  );
}

export default Header;
